var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FE01D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7999 3L16.1998 5.39453L16.1288 5.46568M16.1288 5.46568L13.7999 7.79998M16.1288 5.46568C15.7586 5.4223 15.3818 5.39999 14.9999 5.39999C9.69795 5.39999 5.3999 9.69803 5.3999 14.9999C5.3999 18.0316 6.80518 20.7351 8.99988 22.4944M16.1998 22.2L13.7999 24.4929L13.8355 24.5299M13.8355 24.5299C14.2171 24.5761 14.6058 24.5999 14.9999 24.5999C20.3018 24.5999 24.5998 20.3019 24.5998 14.9999C24.5998 11.9683 23.1945 9.26487 20.9998 7.50553M13.8355 24.5299L16.1998 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.ba86bced96d801127ad6660a44fd09cf.svg";
export { ForwardRef as ReactComponent };